// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"4aebee05d06d8d9a1956","339":"d9a367f2b7315b310a38"}[chunkId] + ".js";
};